import { GameTotalWinCounterProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTotalWinCounterProperties";
export class TotalWinCounterLandscapeProperties extends GameTotalWinCounterProperties {
    constructor() {
        super();
        this.position.set(1551, 338);
    }
}
//# sourceMappingURL=TotalWinCounterLandscapeProperties.js.map